import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { tblToken } from '../../../_models/app-models';
import { TokenService } from '../../../_services/token-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-expiration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expiration.component.html',
  styleUrls: ['./expiration.component.scss']
})
export class ExpirationComponent implements OnInit {
  token: tblToken;
 // defaultCaseNumber = 'E373290011';
  currentYear: number = new Date().getFullYear();
  constructor(
    private tokenService: TokenService,
    private router: Router
  ) {
  }
  ngOnInit(): void {

    if (this.tokenService.token.value?.caseNumber != undefined) {
      this.token = this.tokenService.token.value
    }
    else {
      this.router.navigate(["error"]);
      //this.token = {
      //  caseNumber: this.defaultCaseNumber,
      //  reDueDate: new Date("2022-01-02").toISOString(),
      //  eliasCaseID: "",
      //  formLanguage: "en",
      //  officialFormID: "",
      //  systemUniqueID: "",
      //  accessToken: "",
      //  refreshToken: ""
      //}
    }
  }
  isSpanishlanguage() {
    return this.token.formLanguage == "S"
  }
}
